import { useNavigate } from "react-router-dom"

import { Button, Dropdown } from "@/atoms"
import { NAMES_ROUTES, VALUES_PARAMS } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { FileProtectOutlined } from "@/icons"
import {
  AI_POLICY_KIND_PARAM,
  AI_POLICY_KINDS
} from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"

import type { AiPolicyKind } from "@/api/useAiPolicies.types"
import type { CreateAiPolicyButtonProps } from "./CreateAiPolicyButton.types"

// Creates a policy of the kind picked from its menu, as the open source
// policies' Create Policy button does
export const CreateAiPolicyButton = ({
  withKinds,
  disabled
}: CreateAiPolicyButtonProps) => {
  const navigate = useNavigate()
  const { t: tRoot } = useTranslation()
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.kinds"
  })
  const { ROOT, AI } = NAMES_ROUTES.GOVERNANCE
  const newPolicyUrl = `/${ROOT}/${AI}/${VALUES_PARAMS.NEW_ENTITY}/edit`
  const create = (kind: AiPolicyKind) =>
    navigate(
      kind === "mcpServer"
        ? `${newPolicyUrl}?${AI_POLICY_KIND_PARAM}=${kind}`
        : newPolicyUrl
    )
  const button = (
    <Button
      id="create-ai-policy-button"
      type="primary"
      icon={<FileProtectOutlined />}
      disabled={disabled}
      onClick={withKinds ? undefined : () => create("agent")}
    >
      {tRoot("governance.ai.createPolicy")}
    </Button>
  )

  if (!withKinds) return button

  return (
    <Dropdown
      disabled={disabled}
      trigger={["hover"]}
      menu={{
        items: AI_POLICY_KINDS.map((kind) => ({
          key: kind,
          label: (
            <span data-testid={`create-${kind}-policy`}>
              {t(`${kind}.title`)}
            </span>
          )
        })),
        onClick: ({ key }) =>
          create(AI_POLICY_KINDS.find((kind) => kind === key) ?? "agent")
      }}
    >
      {button}
    </Dropdown>
  )
}
